import { useEffect, useState } from 'react';
import { AiFillHome } from 'react-icons/ai'
import { Link, useNavigate } from 'react-router-dom'
import { useCompany } from '../../../hooks/useCompany';
import Loader from '../../../components/Shared/Loader';
import { api } from '../../../services/axios';
import { toast } from 'react-toastify';
import { formatCurrency } from '../../../utils/formatCurrency';
import { Button, InputAdornment, TextField, Typography } from '@mui/material';
import { BsArrowRightShort } from 'react-icons/bs';
import { Select, Form } from "antd";

interface OptionsProps {
    value: string;
    label: string;
    disabled: boolean;
}

interface BranchCompanyProps {
    id: string;
    cnpj: string;
    name: string;
    uf: string;
    city: string;
    region: string;
}

const options = [
    { value: '1', label: '1º Trimestre', disabled: false },
    { value: '2', label: '2º Trimestre', disabled: false },
    { value: '3', label: '3º Trimestre', disabled: false },
    { value: '4', label: '4º Trimestre', disabled: false }
]

interface InvoincingBalanceSheetValues {
    invoicingTotalValue: number;
    obligationValue: number;
}

export function CreateCredit() {
    const [counting, setCounting] = useState<OptionsProps[]>(options);
    const [countingsSelecteds, setCountingsSelecteds] = useState<OptionsProps[]>([]);
    const [branchCompaniesToSelect, setbranchCompaniesToSelect] = useState<OptionsProps[]>([]);
    const [balanceSheetValue, setBalanceSheetValue] = useState<InvoincingBalanceSheetValues>();
    const [branchCompanySelected, setBranchCompanySelected] = useState<string>("");
    const [branchCompanySelectedLabel, setBranchCompanyLabel] = useState<string>("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { company, updateHeaderValues } = useCompany();
    const { Option } = Select;

    async function getPeriodsSaved() {
        try {
            setLoading(true);
            const isBranch = branchCompanySelected != company.companyId;
            const result = await api.get(`/Credit/GetCreditPeriodsSaved?serviceId=${company.serviceId}&id=${branchCompanySelected}&isBranch=${isBranch}`);

            const response = await result.data;

            const data: string = response.data;

            if (response.statusCode === 200) {
                const splitCountings = data.split(",");

                const countingsAvailable = options.filter(x => {
                    return !splitCountings.includes(x.value)
                });

                setCounting(countingsAvailable);
            }
        } catch (error: any) {
            toast.error(error);
        } finally {
            setLoading(false);
        }
    }

    async function getCNPJsToCredit() {
        try {
            setLoading(true);
            await api.get(`/Credit/GetCNPJsToCredit?companyId=${company.companyId}&serviceId=${company.serviceId}`).then(resp => {
                if (resp.status === 200) {
                    const data: OptionsProps[] = resp.data.data;

                    setbranchCompaniesToSelect(data);
                }
            });
        } catch (error: any) {
            toast.error(error);
        } finally {
            setLoading(false);
        }
    }

    async function handleCreateCredit() {
        try {
            setLoading(true);

            if (countingsSelecteds.length == 0) {
                if (company.counting == 0) {
                    const object = {
                        countings: "0",
                        serviceId: company.serviceId,
                        branchCompanyId: branchCompanySelected != company.companyId ? branchCompanySelected : null
                    }

                    const result = await api.post('/Credit/CreateCredit', object);

                    const response = await result.data;

                    const data = response.data;

                    if (response.statusCode === 200) {
                        await updateHeaderValues();
                        toast.success('Credito criado com sucesso!');
                        navigate(`/${company.serviceId}/credit/tabs/${data.id}/${object.countings}`);
                    }
                } else {
                    toast.error('Selecione um período para continuar');
                }
            }
            else {
                const object = {
                    countings: countingsSelecteds.map(x => x.value).join(','),
                    serviceId: company.serviceId,
                    branchCompanyId: branchCompanySelected != company.companyId ? branchCompanySelected : null
                }

                const result = await api.post('/Credit/CreateCredit', object);

                const response = await result.data;

                const data = response.data;

                if (response.statusCode === 200) {
                    await updateHeaderValues();
                    toast.success('Credito criado com sucesso!');
                    navigate(`/${company.serviceId}/credit/tabs/${data.id}/${object.countings}`);
                }
            }
        }
        catch (error: any) {
            toast.error(error);
        }
        finally {
            setLoading(false);
        }
    }

    async function getInvoicingToBalanceSheet(countingsSelecteds: string, branchSelected: string) {
        try {
            setLoading(true);

            const result = await api.get(`/invoicing/GetInvoicingToBalanceSheet`, {
                params: {
                    serviceId: company.serviceId,
                    countingsSelecteds: countingsSelecteds,
                    branchCompanySelected: branchSelected,
                    matrixCnpj: company.cnpj,
                    isBranch: branchCompanySelected != company.companyId
                }
            });

            const response = await result.data;

            if (response.statusCode === 200) {
                setBalanceSheetValue(response.data);
            }
        }
        catch (error: any) {
            toast.error(error);
        }
        finally {
            setLoading(false);
        }
    }

    async function handleChangeCounting(value: any, option: Array<any>) {
        if (option != null && option != undefined) {

            const optionsSelecteds = Object.values(option).map(x => ({
                value: x.value,
                label: x.children,
                disabled: true,
            }));
            setCountingsSelecteds(optionsSelecteds);
            if (company.counting == 0 && branchCompanySelected) {

                await getInvoicingToBalanceSheet("0", branchCompanySelected);

            } else {
                if (option.some(x => x.key == '0')) {
                    countingsSelecteds.forEach(element => {
                        if (parseInt(element.value) > 0) {
                            element.disabled = true;
                            toast.error('Não é possível realizar uma combinação com o período Anual');
                            setCountingsSelecteds([]);
                        }
                    });
                }

                if (option.some(x => x.key == '1' || x.key == '2' || x.key == '3' || x.key == '4')) {
                    countingsSelecteds.forEach(element => {
                        if (parseInt(element.value) == 0) {
                            element.disabled = true;
                            toast.error('Não é possível realizar uma combinação com o período Anual');
                            setCountingsSelecteds([]);
                        }
                    });
                }

                if (option.length > 0 && branchCompanySelected) {
                    await getInvoicingToBalanceSheet((option.map(x => x.key).join(",")), branchCompanySelected);
                }
            }
        }
    }

    useEffect(() => {
        getCNPJsToCredit();
    }, []);

    useEffect(() => {
        if (branchCompanySelected) {
            getPeriodsSaved();
        }
        if (company.counting == 0) {
            setCountingsSelecteds([{
                value: '0',
                label: 'Anual',
                disabled: true,
            }]);
        }
        handleChangeCounting("0", countingsSelecteds)
    }, [branchCompanySelected]);

    const handleChangeCompany = (value: any, option: any) => {
        if (!Array.isArray(option)) {
            setBranchCompanyLabel(option.children)
            setBranchCompanySelected(option.value);
        }
    };


    return (
        <>
            {loading && <Loader />}
            <div className='card '>
                <div className='card-header'>
                    <div className='breadCrumb'>
                        <Link to={`/${company.serviceId}/home`} className='breadCrumb-home d-flex align-center'>
                            <AiFillHome className='breadCrumb-home' />
                        </Link>
                        <span className='breadCrumb-separator'>{' > '}</span>
                        <span className='breadCrumb-item-actual cursor-pointer' onClick={() => navigate(`/${company.serviceId}/credit`)}>II.2 Faturamentos - Credito financeiro</span>
                        <span className='breadCrumb-separator'>{' > '}</span>
                        <span className='breadCrumb-item'>Criar crédito</span>
                    </div>
                </div>
                <div className='card-body d-flex flex-column align-items-center justify-content-between m-4'>
                    <div className='mb-3 w-100'>
                        <label className='form-label'>Empresas Habilitadas</label>
                        <Form.Item>
                            <Select
                                className="basic-multi-select"
                                placeholder='Selecione...'
                                value={branchCompanySelectedLabel}
                                onChange={handleChangeCompany}
                                dropdownStyle={{ maxHeight: 300, overflowY: 'auto' }}
                                optionLabelProp="label"
                                style={{ minHeight: 56 }}
                            >
                                {branchCompaniesToSelect.length > 0 ? (
                                    branchCompaniesToSelect.map((bcompany) => (
                                        <Option key={bcompany.value} value={bcompany.value}>
                                            {bcompany.label}
                                        </Option>
                                    ))
                                ) : (
                                    <Option disabled>
                                        Não há empresas habilitadas cadastradas no momento!
                                    </Option>
                                )}
                            </Select>
                        </Form.Item>

                    </div>
                    <div className='d-flex mb-4 w-100 h-100'>
                        <div className='w-100 me-4 mb-5'>
                            <label className='form-label m-0'>Período</label>
                            {company.counting == 0
                                ?
                                <><Form.Item><Select
                                    className="w-100 me-4 mb-3"
                                    disabled={true}
                                    style={{ height: '56px' }}
                                    value={[{
                                        value: '0',
                                        label: 'Anual',
                                        disabled: true,
                                    }]}
                                >

                                </Select></Form.Item></>
                                :
                                <Form.Item
                                >
                                    <Select
                                        className="w-100 me-4 mb-3"
                                        disabled={!branchCompanySelected}
                                        mode="multiple"
                                        value={countingsSelecteds}
                                        placeholder='Selecione um ou mais períodos...'
                                        onChange={handleChangeCounting}
                                        dropdownStyle={{ maxHeight: 300, overflowY: 'auto' }}
                                        optionLabelProp="label"
                                        style={{ height: 56, marginTop: 0 }}
                                    >
                                        {
                                            counting.map((count) => (
                                                <Option key={count.value} value={count.value}>
                                                    {count.label}
                                                </Option>
                                            ))
                                        }


                                    </Select>
                                </Form.Item>
                            }  </div>
                        <div className='w-100 me-4'>
                            <Typography variant='body1' component='label'>Valor Faturamento Incentivado Período</Typography>
                            <TextField
                                fullWidth
                                type='text'
                                value={formatCurrency(balanceSheetValue?.invoicingTotalValue.toFixed(2))}
                                InputProps={{
                                    startAdornment: <InputAdornment position='start'>R$</InputAdornment>,
                                    readOnly: true,
                                }}
                            />
                        </div>

                        <div className='w-100 me-4'>
                            <Typography variant='body1' component='label'>Valor Obrigação Período</Typography>
                            <TextField
                                fullWidth
                                type='text'
                                value={formatCurrency(balanceSheetValue?.obligationValue.toFixed(2))}
                                InputProps={{
                                    startAdornment: <InputAdornment position='start'>R$</InputAdornment>,
                                    readOnly: true,
                                }}
                            />
                        </div>
                    </div>
                    {(branchCompanySelected && (company.counting == 0 || countingsSelecteds.length > 0)) &&
                        <Button variant="outlined" className=' ' onClick={handleCreateCredit}><BsArrowRightShort size={20} /> Próximo</Button>
                    }
                </div>
            </div>
        </>
    )
}